import { render, staticRenderFns } from "./payments-table-v2.vue?vue&type=template&id=99a096b2&scoped=true&"
import script from "./payments-table-v2.vue?vue&type=script&lang=js&"
export * from "./payments-table-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a096b2",
  null
  
)

export default component.exports